// useAttemptLedgerFlush.js -- trigger the attempt-ledger flush for the signed-in user.
// Spec: docs/specs/2026-09-29-attempt-ledger.md §4 step 5. Single job: call flushOwner(user.id) on
// mount, on user change, and when the app becomes active. flushOwner is single-flight, so several
// mounted instances are safe. Listener uses the cancelled-flag pattern (useBetsRealtime.js:149).
import { useEffect } from 'react';
import * as Sentry from '../lib/errorReporting';
import { App } from '@capacitor/app';
import { flushOwner } from '../lib/attempt-ledger/flush';

export function useAttemptLedgerFlush(user) {
  const uid = user?.id || null;

  useEffect(() => {
    if (uid) flushOwner(uid);
  }, [uid]);

  useEffect(() => {
    if (!uid) return undefined;
    let handle = null;
    let cancelled = false;
    (async () => {
      try {
        const h = await App.addListener('appStateChange', ({ isActive }) => {
          if (isActive) flushOwner(uid);
        });
        if (cancelled) { h.remove(); return; }
        handle = h;
      } catch {
        // Recoverable: the flush still runs on mount, user change and after each attempt (CC-IMPL-037).
        Sentry.captureMessage('useAttemptLedgerFlush: appStateChange listener unavailable', 'warning');
      }
    })();
    return () => { cancelled = true; if (handle) handle.remove(); };
  }, [uid]);
}
